export const USERDATA = "USERDATA";
export const USERID = "USERID";
export const LOGIN = "LOGIN";
export const SUCCESS_MODAL_TOGGLE = "SUCCESS_MODAL_TOGGLE";
export const REGISTRATION_SUCCESS_MODAL_TOGGLE = "REGISTRATION_SUCCESS_MODAL_TOGGLE";
export const WORNING_MODAL_TOGGLE = "WORNING_MODAL_TOGGLE";
export const WORNING_MODAL_TOGGLE2 = "WORNING_MODAL_TOGGLE2";
export const PROJECT_LIST = 'PROJECT_LIST';
export const BUILDING_LIST = 'BUILDING_LIST';
export const VILLAGES_LIST = 'VILLAGES_LIST';
export const INVESTOR_TYPE = 'INVESTOR_TYPE';
export const PERMISSION_TYPE = 'PERMISSION_TYPE';
export const WATER_SUPPLY = 'WATER_SUPPLY';
export const ELECTRICITY_CONNECTION = 'ELECTRICITY_CONNECTION';
export const DOCNAMES_LIST = 'DOCNAMES_LIST';
export const POC_DESIGNATION = 'POC_DESIGNATION';
export const LOADER = 'LOADER';
export const CITY = 'CITY';
export const CONSTITUTION = 'CONSTITUTION';
export const SUCCESSINFO = 'SUCCESSINFO';
export const REDIRECTLINK = 'REDIRECTLINK';
export const BUILDING_TYPE = 'BUILDING_TYPE';
export const GALA_LIST = 'GALA_LIST';
export const SOLD_GALA_LIST = 'SOLD_GALA_LIST';
export const FLOOR_TYPE = 'FLOOR_TYPE';
export const LOT_INTENT = 'LOT_INTENT';
export const ON_BASIS = 'ON_BASIS';
export const GST = 'GST';
export const HSN = 'HSN';
export const DGST = 'DGST';
export const AGEMODAL = 'AGEMODAL';
export const QUERY = 'QUERY';
export const RESELLREASON = 'RESELLREASON';
export const USERPROJECT = 'USERPROJECT';
export const PROFILEIMG = 'PROFILEIMG';
export const SENDFROMTYPE = 'SENDFROMTYPE';
